/**
 * Shared "centered card" wrapper used by every static / non-chat phase
 * screen (consent / screener / preflight / thank-you variants).
 * Extracted out of MicroResearch.jsx so the page file stays focused on
 * state + business logic.
 */
export default function Centered({ children }) {
  return (
    <div className="min-h-screen bg-[var(--rl-bg-subtle)] flex items-center justify-center px-6 py-12">
      {children}
    </div>
  );
}
